import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  class: "modal-title fs-5",
  id: "userSettingsModalLabel"
}, " User Settings ", -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-dismissible alert-success"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "alert"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Well done!", -1)
const _hoisted_9 = { id: "userSettingsForm" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm",
  for: "newPassword"
}, " Change Password ", -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          ref: "closeModal",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.passwordChanged)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createTextVNode(" You successfully changed your password. ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: _normalizeClass(["form-control form-control-sm", {
                'is-invalid': _ctx.form.currentPassword.errors.length > 0,
              }]),
              placeholder: "Current password",
              id: "currentPassword",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.currentPassword.value) = $event))
            }, null, 2), [
              [_vModelText, _ctx.form.currentPassword.value]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.currentPassword.errors, (error, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "invalid-feedback"
              }, _toDisplayString(error), 1))
            }), 128)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: _normalizeClass(["form-control form-control-sm mt-2", {
                'is-invalid': _ctx.form.newPassword.errors.length > 0,
              }]),
              placeholder: "New password",
              id: "newPassword",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.newPassword.value) = $event))
            }, null, 2), [
              [_vModelText, _ctx.form.newPassword.value]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.newPassword.errors, (error, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "invalid-feedback"
              }, _toDisplayString(error), 1))
            }), 128)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: _normalizeClass(["form-control form-control-sm mt-2", {
                'is-invalid': _ctx.form.newPassword_confirmation.errors.length > 0,
              }]),
              placeholder: "Confirm new password",
              id: "confirmPassword",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.newPassword_confirmation.value) = $event))
            }, null, 2), [
              [_vModelText, _ctx.form.newPassword_confirmation.value]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.newPassword_confirmation.errors, (error, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "invalid-feedback"
              }, _toDisplayString(error), 1))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary mt-2",
              disabled: _ctx.isEmp,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
            }, " Change password ", 8, _hoisted_12)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, " Close ")
      ])
    ])
  ]))
}